










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DAGContainer extends Vue {
  @Prop({ default: '100%' }) width!: string;
  @Prop({ default: '100%' }) height!: string;
}
